import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menumobile from '../partils/menus/menumobile';

import Menumain from '../partils/menus/menumain';

import datahappy  from '../../local/datahappy'
// DATA -------------------------------------------------------------------------

  

export default function Pagemobilemenu() {
    const [loading,setLoading]=useState(false)



    
  return(
    <div className='w100 h100 b33 row around'>
      
      <div className='w100'>
        <Menumain className=""/>
      </div>
      <Menumobile/>
         
    </div>
  )
}










        
